import(/* webpackMode: "eager" */ "/home/bv-fr/next/apps/website/src/app/template.tsx");
